import object from 'helpers/object'


export const initialState = {
  trainers: [],
  statistic: [],
  isFetching: true,
}


export const setTrainers = (state, payload) => (
  object.setIn(state, [ 'trainers' ], payload)
)

export const setStatistic = (state, payload) => (
  object.setIn(state, [ 'statistic' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
